var map = {
	"./automated-ui-delivery-figma-production.md": [
		24019,
		19
	],
	"./build-vs-buy-component-libraries.md": [
		74849,
		849
	],
	"./building-agentic-ai-systems-sdlc.md": [
		10951,
		951
	],
	"./design-tokens-ai-assistants-handoff.md": [
		27677,
		677
	],
	"./edge-rendering-local-first-applications.md": [
		46018,
		18
	],
	"./final-nail-in-lodash-coffin.md": [
		98388,
		388
	],
	"./frontend-architecture-aws-scale.md": [
		14581,
		581
	],
	"./future-of-frontend-beyond-browser.md": [
		6549,
		549
	],
	"./monolithic-frontend-comeback.md": [
		9717,
		717
	],
	"./rise-of-async-work.md": [
		16801,
		801
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80045;
module.exports = webpackAsyncContext;